import { atom } from 'recoil';

export const network = atom({
  key: 'network',
  default: true,
});
